module.exports = __webpack_public_path__ + "img/DCOM.7040979b.svg";